import React,{useEffect,useState} from "react"
import {Form,Col} from 'react-bootstrap'

function Fdg_pet_brain(props){
    const [disabled,setDisabled] = useState(true)
    const handleChange = (event) =>{
        if(event.target.value=="Yes"){
            setDisabled(false)
        }
        else{
            setDisabled(true)
        }
        props.handler("fdg_pet_brain",event)
    }
    useEffect(()=>{
        if(props.data['fdg_pet_brain'] =="No"){
            setDisabled(true)
            let e = {}
            e.name ='hypometabolism_pd'
            e.value=""
            props.handler("fdg_pet_brain",e)
            
            
            e.name ='hypometabolism_psp'           
            props.handler("fdg_pet_brain",e)

            e.name ='hypometabolism_msa'           
            props.handler("fdg_pet_brain",e)

            e.name ='hypometabolism_ad'            
            props.handler("fdg_pet_brain",e)

            e.name ='hypometabolism_ftd'            
            props.handler("fdg_pet_brain",e)

            e.name ='hypometabolism_dlb'            
            props.handler("fdg_pet_brain",e)

            e.name ='fdg_pet_brain_date'
            props.handler("fdg_pet_brain",e)
            
            
            
        }
    },[props.data['fdg_pet_brain']])
    useEffect(()=>{
        if(props.data['fdg_pet_brain'] =="Yes"){
        setDisabled(props.disabled)
        }
    },[props.disabled])
    return(
        <Form>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label>FDG-PET Brain</Form.Label>
                    <Form.Control as={'select'} onChange={handleChange} name={'fdg_pet_brain'}value={props.data['fdg_pet_brain']} disabled={props.edit?true:false}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Col>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with PD </Form.Label>
                    <Form.Control as={'select'} onChange={(event)=> props.handler("fdg_pet_brain",event)} name={'hypometabolism_pd'}value={props.data['hypometabolism_pd']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with PSP </Form.Label>
                    <Form.Control as={'select'}  onChange={(event)=> props.handler("fdg_pet_brain",event)} name={'hypometabolism_psp'}value={props.data['hypometabolism_psp']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with MSA </Form.Label>
                    <Form.Control as={'select'}  onChange={(event)=> props.handler("fdg_pet_brain",event)} name={'hypometabolism_msa'}value={props.data['hypometabolism_msa']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with AD </Form.Label>
                    <Form.Control as={'select'}  onChange={(event)=> props.handler("fdg_pet_brain",event)} name={'hypometabolism_ad'}value={props.data['hypometabolism_ad']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with FTD</Form.Label>
                    <Form.Control as={'select'}  onChange={(event)=> props.handler("fdg_pet_brain",event)}name={'hypometabolism_ftd'}value={props.data['hypometabolism_ftd']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group >
                    <Form.Label>Hypometabolism consistent with DLB</Form.Label>
                    <Form.Control as={'select'}  onChange={(event)=> props.handler("fdg_pet_brain",event)}name={'hypometabolism_dlb'}value={props.data['hypometabolism_dlb']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>
                    </Form.Control>
                </Form.Group>

                </Col>
                <Form.Group as={Col}>
                        <Form.Label>Date</Form.Label>
                        <Form.Control name={'fdg_pet_brain_date'} type={'date'}  onChange={(event)=> props.handler("fdg_pet_brain",event)} value={props.data["fdg_pet_brain_date"]} disabled={props.edit? true :disabled}/>
                </Form.Group>
                
            </Form.Row>
        </Form>
    )
}
export default  Fdg_pet_brain